/**
 * @name useEmpty
 * @param data {object} Example: { name: 'John' } || ['', ''] || ""
 * @returns {boolean} Example: true || false
 */
function useEmpty(data: string | object | null | boolean | undefined): boolean {
    if (data === null || data === undefined || data === '' || data === false)
        return true
    if (typeof data === 'object') {
        return Object.values(data).every(
            (x) => x === null || x === undefined || x === ''
        )
    }
    return false
}

export { useEmpty }

Boolean()
